export class FilterForum  {
  courses: any[];
  groups: any[];
  teachers: any[];
}
